import { useState } from "react";
import { faqItems } from "@/mocks/jiuse";

const trustPoints = [
  { icon: "ri-archive-2-line", text: "图片、视频、截图分页归档，查找省力" },
  { icon: "ri-zoom-in-line", text: "保留更高解析度批次，点开即看原图级画面" },
  { icon: "ri-history-line", text: "每次更新都有时间线可反查，版本不混淆" },
  { icon: "ri-customer-service-2-line", text: "想找哪类细节，可直接按题材分区直达" },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.5fr] lg:gap-12">
          {/* 左侧信任说明 */}
          <div className="lg:sticky lg:top-24 lg:self-start">
            <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-[0.26em] text-primary-700">
              <i className="ri-question-answer-line text-sm" aria-hidden="true" />
              读者常问 · 信任说明
            </p>
            <h2 className="font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              关于本页，常见问题一次说清
            </h2>
            <p className="mt-3 max-w-md text-[14px] leading-7 text-foreground-600">
              无论你是第一次来翻九色黑料图片，还是想细看九色黑料视频与截图细节，这份说明都能帮你更快上手。
            </p>
            <ul className="mt-6 space-y-3">
              {trustPoints.map((p, idx) => (
                <li key={idx} className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
                  <span className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-md bg-primary-100 text-primary-700">
                    <i className={p.icon} aria-hidden="true" />
                  </span>
                  <span className="text-[13px] font-medium leading-6 text-foreground-800">{p.text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* 右侧问答折叠 */}
          <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-100/50">
            {faqItems.map((it, idx) => {
              const isOpen = openIdx === idx;
              return (
                <div key={idx}>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIdx(isOpen ? null : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-background-50"
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 font-display text-sm font-bold text-primary-600">Q{idx + 1}</span>
                      <span className="font-display text-[15px] font-bold leading-snug text-foreground-950">{it.q}</span>
                    </span>
                    <i
                      className={
                        "shrink-0 text-xl text-foreground-500 transition " + (isOpen ? "ri-subtract-line" : "ri-add-line")
                      }
                      aria-hidden="true"
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 pl-[52px]">
                      <p className="text-[13px] leading-7 text-foreground-600">{it.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}